"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons");

var _liveAnnouncer = require("../live-announcer");

var _utils = require("../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var CardStatusIconWrapper = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "e1meyhb80"
})({
  position: 'absolute',
  right: (0, _utils.px)(_constants.CARD_STATUS_ICON_SPACING),
  top: (0, _utils.px)(_constants.CARD_STATUS_ICON_SPACING)
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2NhcmQvQ2FyZFN0YXR1c0ljb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCOEIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL3N1Ym1vZHVsZXMvY2FyZC9DYXJkU3RhdHVzSWNvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IEljb25TaXplIH0gZnJvbSAnLi4vaWNvbnMnO1xuaW1wb3J0IHsgTGl2ZVJlZ2lvbiwgTGl2ZVJlZ2lvblJvbGUgfSBmcm9tICcuLi9saXZlLWFubm91bmNlcic7XG5pbXBvcnQgeyBweCB9IGZyb20gJy4uL3V0aWxzJztcblxuaW1wb3J0IHtcbiAgQ0FSRF9TVEFUVVNfSUNPTl9TUEFDSU5HLFxuICBDYXJkU3RhdHVzSWNvbkNvbG9ycyxcbiAgQ2FyZFN0YXR1c0ljb25zLFxuICBDYXJkU3RhdHVzSWNvbnNEZWZhdWx0VGV4dHNcbn0gZnJvbSAnLi9jb25zdGFudHMnO1xuaW1wb3J0IHsgQ2FyZFN0YXR1cywgQ2FyZFN0YXR1c1Byb3BzIH0gZnJvbSAnLi9pbnRlcmZhY2VzJztcblxuY29uc3QgQ2FyZFN0YXR1c0ljb25XcmFwcGVyID0gc3R5bGVkKCdkaXYnKSh7XG4gIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICByaWdodDogcHgoQ0FSRF9TVEFUVVNfSUNPTl9TUEFDSU5HKSxcbiAgdG9wOiBweChDQVJEX1NUQVRVU19JQ09OX1NQQUNJTkcpXG59KTtcblxuY29uc3QgQ2FyZFN0YXR1c0ljb24gPSAoe1xuICBzdGF0dXMgPSBDYXJkU3RhdHVzLkRlZmF1bHQsXG4gIHN0YXR1c0ljb25BbHRUZXh0XG59OiBDYXJkU3RhdHVzUHJvcHMpID0+IHtcbiAgY29uc3QgSWNvbiA9IENhcmRTdGF0dXNJY29uc1tzdGF0dXNdO1xuXG4gIHJldHVybiAoXG4gICAgPENhcmRTdGF0dXNJY29uV3JhcHBlcj5cbiAgICAgIDxMaXZlUmVnaW9uIGFyaWEtbGl2ZT1cInBvbGl0ZVwiIHJvbGU9e0xpdmVSZWdpb25Sb2xlLlN0YXR1c30+XG4gICAgICAgIDxJY29uXG4gICAgICAgICAgY29sb3I9e0NhcmRTdGF0dXNJY29uQ29sb3JzW3N0YXR1c119XG4gICAgICAgICAgc2l6ZT17SWNvblNpemUuTWVkaXVtfVxuICAgICAgICAgIHRpdGxlPXtzdGF0dXNJY29uQWx0VGV4dCB8fCBDYXJkU3RhdHVzSWNvbnNEZWZhdWx0VGV4dHNbc3RhdHVzXX1cbiAgICAgICAgLz5cbiAgICAgIDwvTGl2ZVJlZ2lvbj5cbiAgICA8L0NhcmRTdGF0dXNJY29uV3JhcHBlcj5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENhcmRTdGF0dXNJY29uO1xuIl19 */");

var CardStatusIcon = function CardStatusIcon(_ref) {
  var _ref$status = _ref.status,
      status = _ref$status === void 0 ? _interfaces.CardStatus.Default : _ref$status,
      statusIconAltText = _ref.statusIconAltText;
  var Icon = _constants.CardStatusIcons[status];
  return (0, _core.jsx)(CardStatusIconWrapper, null, (0, _core.jsx)(_liveAnnouncer.LiveRegion, {
    "aria-live": "polite",
    role: _liveAnnouncer.LiveRegionRole.Status
  }, (0, _core.jsx)(Icon, {
    color: _constants.CardStatusIconColors[status],
    size: _icons.IconSize.Medium,
    title: statusIconAltText || _constants.CardStatusIconsDefaultTexts[status]
  })));
};

var _default = CardStatusIcon;
exports.default = _default;